import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import SettingListItem from '../SettingListItem';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const ClassLevels = () => {

    const {openSettings} = useTheme();

    const [activeRecord, setActiveRecord] = useState(null);
    const {getClassLevels, classLevels} = useConfig();


    useEffect(()=>{
        getClassLevels();
    }, [])

    const handleNew = ()=>{
        openSettings("New Class Level", "NewClassLevel");
    }

    const handleEdit = ()=>{
        openSettings("Edit Class Level", "EditClassLevel", activeRecord);
    }

   
    const menu = ()=>{

        return(<>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-pencil"> </i><span>Create Class Level</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit"> </i><span>Edit Selection</span>
            </button>
        </>)
    }

    return (
        <SettingContainer
            title="Class Levels"
            icon="fa fa-bookmark"
            Menu={menu}
            >
      
            {Array.isArray(classLevels) && <ul className="list-group">
                {classLevels.map((item) => (
                    
                    <SettingListItem
                        key={item.level_id} 
                        iconName='fa fa-cog'
                        itemName={item.level}
                        onSelect={()=>setActiveRecord(item)}
                        active={item.level_id === activeRecord?.level_id}
                    />
                        
                ))}
            </ul>}
            {classLevels === '404' && <Notification message="No class level found" />}
            {!classLevels && <ActivityLoader />}
       </SettingContainer>

      
    );
};

export default ClassLevels;
